import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {ApplicationFlowType} from './residence-info.component';
import { Injectable } from "@angular/core";

@Injectable()
export class ResidenceInfoLinksResolver implements Resolve<{ back: string, forward: string }> {

    public resolve(route: ActivatedRouteSnapshot, routerStateSnapshot: RouterStateSnapshot): { back: string, forward: string } {
        if (route.data.applicationFlowType === ApplicationFlowType.LoanApplicationFlow) {
            return {back: '/borrowedinfo', forward: '/uploaddocuments'};
        } else if (route.data.applicationFlowType === ApplicationFlowType.LenderApplicationFlow) {
            return {back: '/lenderpersonalinfo', forward: '/lenderbankdetails'};
        }
    }
}